import { render, staticRenderFns } from "./ProductsStore.vue?vue&type=template&id=68f8d8f2&"
import script from "./ProductsStore.vue?vue&type=script&lang=js&"
export * from "./ProductsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports